import { PageType } from '@core/enums';
import ArticleCard from '@stories/Components/Cards/ArticleCard/ArticleCard';
import EventCard from '@stories/Components/Cards/EventCard/EventCard';
import ResourceCard from '@stories/Components/Cards/ResourceCard/ResourceCard';
import React from 'react';
import { FeaturedArticleStyles as S } from './FeaturedArticle.styles';
const FeaturedArticle = ({ card, id, title, pageType }) => {
    return (React.createElement(S.Container, { id: id },
        title && React.createElement(S.Title, null, title),
        card &&
            (() => {
                switch (pageType) {
                    case PageType.News:
                        return React.createElement(ArticleCard, { ...card });
                    case PageType.Events:
                        return React.createElement(EventCard, { ...card });
                    case PageType.Resources:
                        return React.createElement(ResourceCard, { ...card });
                }
            })()));
};
export default FeaturedArticle;
